'use strict';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  createUpdateApplicant, getYtjInformation, createSaveApplication,
  getFetchApplication, getValidateEmail, getValidatePhone,
  getValidatePhoneWithCode, getValidateEmailWithCode, getAsiakastietoScoringData
} from '../../actions/application';
import { GetAuthenticationSession, createLoginToken } from '../../actions/login';
import * as affiliationTracking from '../utils/affiliationTracking';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button'
import MaskedInput from 'react-text-mask';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/styles';

import { FormControl } from '@material-ui/core';

import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import IconAdd from '@material-ui/icons/Add';
import IconRemove from '@material-ui/icons/Remove';

import IconOk from '@material-ui/icons/Done';
import IconError from '@material-ui/icons/Error';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import { GetFetchOffer } from '../../actions/loanOffer';
import Snack from '../utils/snack'
import CircularProgress from '@material-ui/core/CircularProgress';
import { GeneralFooter } from '../utils/generalFooter';
import ApplicationDetails from './applicationDetails';
import LoanPaymentDetails from './loanPaymentDetails';
import OptionalAttachments from './optionalAttachments';
import queryString from 'query-string'
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import Switch from '@material-ui/core/Switch';
import Slider from '@material-ui/core/Slider';
import Collapse from '@material-ui/core/Collapse';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

import checkmarkImage from '../../img/checkmark.svg';
import { COLOR_CENTER_BORDER } from '../../theme/tokens';
import hero from '../../Hero.webp';
import { trackLoanApplication, trackButtonClick, trackEvent } from '../../utils/gtm';
import BankSelectionPanel from '../BankSelectionPanel';

const maxAmt = 250000;
const minAmt = 2000;
const amtStep = 1000;
const maxLen = 48;
const minLen = 1;
const lenStep = 1;
const maxFree = 3;
const minFree = 0;

const styles = theme => ({
  '@keyframes pointNudge': {
    '0%, 70%, 100%': { transform: 'translateX(0) translateY(-50%)' },
    '80%': { transform: 'translateX(-8px) translateY(-50%)' },
    '90%': { transform: 'translateX(0) translateY(-50%)' },
  },
  pointingFinger: {
    display: 'inline-block',
    fontSize: '24px',
    animation: '$pointNudge 2s ease-in-out infinite',
    zIndex: 10,
    opacity: 0.9,
  },
  checkmarkList: {
    textAlign: 'left',
    padding: 0,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    '& > li': {
      display: 'inline-block',
      '& > *': {
        display: 'inline-block',
        lineHeight: `${theme.spacing(3)}px`,
        verticalAlign: 'middle',
      },
      '&:not(:last-of-type)': {
        marginRight: '26px',
      },
      '&::before': {
        content: `url(${checkmarkImage})`,
        display: 'inline-block',
        verticalAlign: 'middle',
        marginRight: 10,
        height: `${theme.spacing(3)}px`,
      },
    },
  },
  calculatorMonthlyPaymentDetailBox: {
    padding: '2px !important',
    borderWidth: '1px 0 1px 1px',
    borderStyle: 'solid',
    borderColor: '#EBEBEA',
    borderRadius: '8px',
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      borderWidth: '1px 1px 0 1px',
      padding: theme.spacing(1),
      '&:last-of-type': {
        borderBottomWidth: '1px',
      },
    },
    '&:last-of-type': {
      borderRightWidth: '1px',
    },
  },
  calculatorSliderText: {
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '28px',
    letterSpacing: '0.01em',
  },
  calculatorNumber: {
    fontWeight: 500,
    fontSize: 22,
    lineHeight: '28px',
    letterSpacing: '-0.2px',
  },
});

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix="$"
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

function getSimpleSteps() {
  return ['Rahoituksen perustiedot', 'Tunnistautuminen'];
}

const mapStateToProps = (state) => {
  return {
    application: state.application,
    offer: state.offer,
    authentication: state.auth
  };
};

const purposeStyle = {
  width: '200px',
  marginTop: '10px',
  fontSize: '10px'
}

const textStyle = {
  color: "black"
};
const iconStyle = {
  height: '15px'
}
const errorStyle = {
  color: 'red',
  marginTop: '20px'
}

const okStyle = {
  color: 'lightgreen',
  marginTop: '20px'
}


const mapDispatchToProps = (dispatch) => {
  return {

    updateApplication: (application) => dispatch(createUpdateApplicant(application)),
    getOffer: (loanAmt, loanLen, dueDate, capitalFreeMonths) => dispatch(GetFetchOffer(loanAmt, loanLen, dueDate, capitalFreeMonths)),
    getYtjInformation: (bic) => dispatch(getYtjInformation(bic)),
    getAuth: (id) => dispatch(GetAuthenticationSession(id)),
    saveApplication: (application) => dispatch(createSaveApplication(application)),
    fetchApplication: (application) => dispatch(getFetchApplication(application)),
    valEmail: (application) => dispatch(getValidateEmail(application)),
    valPhone: (application) => dispatch(getValidatePhone(application)),
    tryValEmailCode: (application) => dispatch(getValidateEmailWithCode(application)),
    tryValPhoneCode: (application) => dispatch(getValidatePhoneWithCode(application)),
    getScoringData: (application) => dispatch(getAsiakastietoScoringData(application)),
    createLoginToken: (serviceId, applicationContext, applicationId) => dispatch(createLoginToken(serviceId, applicationContext, applicationId)),

  };
};

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/]}
      
      keepCharPositions={false}
      showMask={false}
      InputLabelProps={{
        shrink: true,
      }}
      placeholderChar={'\u2000'}
    />
  );
}

function getSteps() {
  return ['Haettava rahoitus', 'Yrityksen tiedot', 'Yhteyshenkilön tiedot', 'Tunnistautuminen'];
}

function getStepContent(step) {
  switch (step) {
    case 0:
      return '';
    case 1:
      return '';
    case 2:
      return '';
    default:
      return '';
  }
}

export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

export function getGclidFromQuery(queryString) {
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get('gclid');
}

export function getFbclidFromQuery(queryString) {
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get('fbclid');
}

class BecomeApplicantProcess extends Component {
  getOfferDebounceHandler = null;
  processStartedEventFired = false; // Track if kr_process_started event has been fired (uses instance variable to avoid setState race conditions)
  
  // Store tracking values in instance variables to prevent them from being lost during state updates
  _trackingAffiliateBrowserId = '';
  _trackingGa4ClientId = '';
  _trackingGa4SessionId = '';

  constructor(props) {
    //For loan application type to update properly, we have to parse query string when state is initialized
    const values = queryString.parse(props.authUserId.params.id);
    const query = queryString.parse(props.search);

    let consolidation = 0;
    if (query.replace === '1' || values.replace === '1' || query.consolidation === 'true') {
      consolidation = 1;
    }
    
    super(props);
    this.state = {
      application: {
        loanAmount: 20000,
        loanLength: 12,
        capitalFreeMonths: 0,
        LoanPurposeTypeEnum: 0,
        LoanGuaranteeTypeEnum: 0,
        LoanDueDateTypeEnum: 0,
        freeMonthsToPaymentsCheck: false,
        ApplicationSource: "",
        bic: "",
        loanApplicationTypeEnum:consolidation,
        affiliateCode: "",
        affiliate: "",
        affiliateBrowserId: "",
        ga4ClientId: "",
        ga4SessionId: ""
      },
      activeStep: 0,
      validation: {
        amountError: false,
        lengthError: false,
        lastNameError: false,
        passwordAgainError: false,
        emailMissing: false,
      },
      isEmailValidationRequested: false,
      isEmailValidated: false,
      isPhoneValidationRequested: false,
      isPhoneValidated: false,
      isPasswordSet: false,
      isAuthenticated: false,
      canStep1forward: true,
      canStep2forward: false,
      canStep3forward: false,
      terms: false,
      creditCheck: false,
      defaultCheck: false,
      completeEventSent: false,
      attachments: [],
      isUploading: false,
      authenticatingServiceId: null,
      bankDrawerOpen: false,
      isSavingAfterStep1: false,
      formInteractionStarted: false // Track if user has started interacting with form
    };

    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleAmountChange = this.handleAmountChange.bind(this);
    this.handleAmountChangeSlider = this.handleAmountChangeSlider.bind(this);
    this.handleLengthChangeSlider = this.handleLengthChangeSlider.bind(this);

    this.handleLengthChange = this.handleLengthChange.bind(this);
    this.validateEmailClick = this.validateEmailClick.bind(this);
    this.requestNewEmailVerificationClick = this.requestNewEmailVerificationClick.bind(this);
    this.handleEmailVerificationChange = this.handleEmailVerificationChange.bind(this);
    this.validatePhoneClick = this.validatePhoneClick.bind(this);
    this.requestNewPhoneVerificationClick = this.requestNewPhoneVerificationClick.bind(this);
    this.handlePhoneVerificationChange = this.handlePhoneVerificationChange.bind(this);
    this.handleLoanPurposeTypeEnumChange = this.handleLoanPurposeTypeEnumChange.bind(this);
    this.handleLoanDueDateTypeEnumChange = this.handleLoanDueDateTypeEnumChange.bind(this);
    this.authenticate = this.authenticate.bind(this);
    this.validatePasswordAgain = this.validatePasswordAgain.bind(this);
    this.incLength = this.incLength.bind(this);
    this.decLength = this.decLength.bind(this);
    this.incAmt = this.incAmt.bind(this);
    this.decAmt = this.decAmt.bind(this);
    this.validateFirstView = this.validateFirstView.bind(this);
    this.handleAttachmentsChange = this.handleAttachmentsChange.bind(this);
    this.handleFormInteractionStart = this.handleFormInteractionStart.bind(this);

  }

  // Handle form interaction start and trigger GTM event
  handleFormInteractionStart = () => {
    const processName = this.state.application.loanApplicationTypeEnum === 1 ? 'combine_loans' : 'loan';
    const storageKey = `kr_process_started_${processName}`;
    
    // Use instance variable to prevent race conditions AND localStorage to persist across page reloads
    if (!this.processStartedEventFired && !localStorage.getItem(storageKey)) {
      this.processStartedEventFired = true;
      localStorage.setItem(storageKey, 'true');
      this.setState({ formInteractionStarted: true });
      
      // Send GTM event for loan application form interaction started
      trackEvent('kr_process_started', {
        "process_name": processName
      });
      
    }
  }

  incLength = () => {
    let val = parseInt(this.state.application.loanLength);
    val = val + lenStep;
    if (val > maxLen)
      val = maxLen;
    this.setState(...this.state, {
      application: {
        ...this.state.application,
        loanLength: val
      }
    });

  }
  decLength = () => {
    let val = this.state.application.loanLength;
    val = val - lenStep;
    if (val < minLen)
      val = minLen;
    this.setState(...this.state, {
      application: {
        ...this.state.application,
        loanLength: val
      }
    });
  }

  incFree = () => {
    let val = this.state.application.capitalFreeMonths;
    val = val + lenStep;
    if (val > maxFree)
      val = maxFree;
    this.setState(...this.state, {
      application: {
        ...this.state.application,
        capitalFreeMonths: val
      }
    });

  }
  decFree = () => {
    let val = this.state.application.capitalFreeMonths;
    val = val - lenStep;
    if (val < minFree)
      val = minFree;
    this.setState(...this.state, {
      application: {
        ...this.state.application,
        capitalFreeMonths: val
      }
    });
  }




  validateFirstView = () => {
    // valid fields

    let email = this.state.application.email !== undefined && this.isEmailOk(this.state.application.email);
    let name = this.state.application.companyName !== undefined && this.state.application.companyName.length > 0
    let phone = this.state.application.phone !== undefined && this.isPhoneOk(this.state.application.phone);
    let bic = this.state.application.bic !== undefined && this.state.application.bic.length > 0;
    let check = this.state.defaultCheck;
    this.setState({
      ...this.state,
      validation:
      {
        ...this.state.validation,
        emailError: !email,
        companyNameError: !name,
        phoneError: !phone,
        BICError: !bic,
      }
    }, () => {
      if (this.state.defaultCheck !== true)
        this.setState({
          ...this.state,
          defaultRequired: true
        }, () => {

        })
    });
    if (email && name && phone && bic && check)
      this.handleNext();

  }

  incAmt = () => {
    let val = parseInt(this.state.application.loanAmount);
    val = val + amtStep;
    if (val > maxAmt)
      val = maxAmt;
    this.setState(...this.state, {
      application: {
        ...this.state.application,
        loanAmount: val
      }
    });
  }

  decAmt = () => {
    let val = this.state.application.loanAmount;
    val = val - amtStep;
    if (val < minAmt)
      val = minAmt;
    this.setState(...this.state, {
      application: {
        ...this.state.application,
        loanAmount: val
      }
    });


  }

  handleAttachmentsChange = (attachments) => {
    this.setState({
      ...this.state,
      attachments: attachments
    });
  }

  authenticate = async (serviceId) => {
    console.log("authenticate called with serviceId:", serviceId, "saving application with attachments first");
    console.log("current attachments state:", this.state.attachments);
    
    // Clear previous upload logs
    localStorage.removeItem('uploadLogs');
    
    // Show loading state with the selected bank serviceId
    this.setState({ ...this.state, isUploading: true, authenticatingServiceId: serviceId });
    
    // Save the application with attachments before authentication
    let appl = { ...this.state.application }
    const applicationWithAttachments = { 
      ...appl, 
      monthlyPayment: this.props.offer?.offerdata?.loanDetails?.monthlyPmt || 0, 
      attachments: this.state.attachments 
    };
    
    console.log("saving application before authentication:", applicationWithAttachments);
    
    try {
      // Save application and wait for it to complete (including file uploads)
      const savedApplication = await this.props.saveApplication(applicationWithAttachments);
      console.log("application and attachments saved successfully, proceeding with authentication");
      
      // Hide loading state
      this.setState({ ...this.state, isUploading: false, authenticatingServiceId: null });
      
      // Add a small delay to ensure all uploads are complete
      setTimeout(() => {
        // Use createLoginToken which will handle getting the token and redirecting to NETS
        // serviceId selects the specific bank (0-10) or 11 for generic NETS bank picker
        this.props.createLoginToken(serviceId, 3, savedApplication.id);
      }, 500);
      
    } catch (error) {
      console.error("Error saving application:", error);
      
      // Send GTM error event
      const processName = this.state.application.loanApplicationTypeEnum === 1 ? 'combine_loans' : 'loan';
      trackEvent('kr_process_error', {
        "process_name": processName,
        "error_message": error.message || "Error saving application before authentication"
      });
      
      // Hide loading state
      this.setState({ ...this.state, isUploading: false, authenticatingServiceId: null });
      // Still proceed with authentication even if save fails
      setTimeout(() => {
        this.props.createLoginToken(serviceId, 3, this.props.application.id);
      }, 500);
    }
  }

  validatePasswordAgain = () => {
    if (this.state.application.password !== this.state.application.passwordAgain) {
      this.setState({
        ...this.state,
        validation:
          { ...this.state.validation, passwordAgainError: true }
      })
    } else {
      this.setState({
        ...this.state,
        validation:
          { ...this.state.validation, passwordAgainError: false }
      })
    }
  }


  validateEmailClick = () => {
    this.setState({ ...this.state, isEmailValidationRequested: true });
    this.props.valEmail(this.state.application);
    //dispatch send code
    //add notification class to div      
  }

  requestNewEmailVerificationClick = () => {
    //dispatch resend code
  }

  handleEmailVerificationChange = (event) => {
    let val = event.target.value;
    //dispatch check code
  }

  handleTermsClick = (event) => {
    this.setState({ ...this.state, terms: event.target.checked })
  }


  handleDefaultCheckClick = (event) => {
    this.handleFormInteractionStart(); // Trigger GTM event on first interaction
    
    let checked = event.target.checked;
    this.setState({ ...this.state, defaultCheck: checked }, () => {
      if (checked && this.state.defaultRequired)
        this.setState({ ...this.state, defaultRequired: false })
    })
  }

  handleApplicationTypeCheckClick = (event) => {
    this.handleFormInteractionStart(); // Trigger GTM event on first interaction
    
    let checked = event.target.checked;
    let val = 0;
    if (checked === true)
      val = 1;
    this.setState({
      application: {
        ...this.state.application,
        loanApplicationTypeEnum: val
      }
    }
    );
  }

  handlefreeMonthsToPaymentsCheckClick = (event) => {
    let checked = event.target.checked;
    let val = 0;
    if (checked === true)
      val = 1;

    if (val === 0) {
      this.setState({
        application: {
          ...this.state.application,
          freeMonthsToPaymentsCheck: val, capitalFreeMonths: 0
        }
      });
    }

    if (val === 1) {
      this.setState({
        application: {
          ...this.state.application,
          freeMonthsToPaymentsCheck: val, capitalFreeMonths: 1
        }
      });
    }

  }


  validatePhoneClick = () => {
    this.setState({ ...this.state, isPhoneValidationRequested: true });
    this.props.valPhone(this.state.application);

    //add notification class to div
    //dispatch send code
  }

  requestNewPhoneVerificationClick = () => {
    //dispatch resend code
  }

  handlePhoneVerificationChange = (event) => {
    let val = event.target.value;
    //dispatch check code
  }

  componentWillReceiveProps = (nextProps) => {

    if (nextProps.application.zip !== this.props.zip ||
      nextProps.application.contactDetails !== this.props.contactDetails ||
      nextProps.application.address !== this.props.address ||
      nextProps.application.id !== this.props.id) {
      
      console.log('COMPONENTWILLRECEIVEPROPS: Syncing props to state');
      console.log('CWRP: Instance variables (source of truth):', {
        _trackingAffiliateBrowserId: this._trackingAffiliateBrowserId,
        _trackingGa4ClientId: this._trackingGa4ClientId,
        _trackingGa4SessionId: this._trackingGa4SessionId
      });
      console.log('CWRP: Current state tracking:', {
        affiliateBrowserId: this.state.application.affiliateBrowserId,
        ga4ClientId: this.state.application.ga4ClientId,
        ga4SessionId: this.state.application.ga4SessionId
      });
      console.log('CWRP: Incoming props tracking:', {
        affiliateBrowserId: nextProps.application.affiliateBrowserId,
        ga4ClientId: nextProps.application.ga4ClientId,
        ga4SessionId: nextProps.application.ga4SessionId
      });
      
      this.setState({
        application:
        {
          ...this.state.application,
          ...nextProps.application,
          // ALWAYS use instance variables as source of truth (set once in componentDidMount)
          affiliateBrowserId: this._trackingAffiliateBrowserId || nextProps.application.affiliateBrowserId || '',
          ga4ClientId: this._trackingGa4ClientId || nextProps.application.ga4ClientId || '',
          ga4SessionId: this._trackingGa4SessionId || nextProps.application.ga4SessionId || ''
        }
      }, () => {
        console.log('CWRP: After setState, tracking values:', {
          affiliateBrowserId: this.state.application.affiliateBrowserId,
          ga4ClientId: this.state.application.ga4ClientId,
          ga4SessionId: this.state.application.ga4SessionId
        });
      })
    }

    if (nextProps.authentication
      && nextProps.authentication.isAuthenticated
      && nextProps.authentication.isAuthenticated === true) {
      this.setState({ ...this.state, activeStep: 4 },)
    }
  }


  handleAmountChange = (event) => {
    let val = 0;
    let selVal = 0;
    /*
    if (event.target.value === "" || event.target.value === undefined) 
      val = 2000
    else 
    */
    val = parseInt(event.target.value);

    if (val <= maxAmt && val >= minAmt)
      selVal = val;


    this.setState(...this.state, {
      application: {
        ...this.state.application,
        loanAmount: val
      }
    });
  };


  handleLengthChange = (event) => {

    let val = 0;
    let selVal = 0;
    val = parseInt(event.target.value);

    if (val <= maxLen && val >= minLen)
      selVal = val;

    /* if (event.target.value === "" || event.target.value === undefined) 
      val = 1
    else 
      val = parseInt(event.target.value);
      
    if (val > 24)
      val = 24;
    if (val < 1)
      val = 1;
      */
    this.setState({
      application: {
        ...this.state.application,
        loanLength: val
      }
    });

  };


  handleFreeMonthsChange = (event, value) => {
    this.handleFormInteractionStart(); // Trigger GTM event on first interaction

    let val = parseInt(value);
    let selVal = 0;

    if (val <= maxFree && val >= minFree)
      selVal = val;

    if (val < minFree)
      val = minFree;

    if (val > maxFree)
      val = maxFree;


    /* if (event.target.value === "" || event.target.value === undefined) 
      val = 1
    else 
      val = parseInt(event.target.value);
      
    if (val > 24)
      val = 24;
    if (val < 1)
      val = 1;
      */
    this.setState({
      application: {
        ...this.state.application,
        capitalFreeMonths: val
      }
    });

  };


  handleAmountChangeSlider = (event, value) => {
    this.handleFormInteractionStart(); // Trigger GTM event on first interaction
    
    let val = parseInt(value);
    this.setState({
      application: {
        ...this.state.application,
        loanAmount: val
      }
    });
  };



  handleLengthChangeSlider = (event, value) => {
    this.handleFormInteractionStart(); // Trigger GTM event on first interaction
    
    let val = parseInt(value);
    this.setState({
      application: {
        ...this.state.application,
        loanLength: val
      }
    });
  };





  handleCbChange = name => (event, checked) => {
    this.setState({
      application: {
        ...this.state.application,
        [name]: checked
      }
    });
  };
  // validations



  isEmailOk = (val) => {
    this.setState({ validation: { ...this.state.validation, emailFormatError: false } });
    if (val === undefined || val === "") {
      return false;
    }
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let emailOk = re.test(val);

    return emailOk;
  }

  isPhoneOk = (val) => {
    return true;
  }

  validateEmail = () => {
    if (this.isEmailOk(this.state.application.email)) {
      this.setState({ validation: { ...this.state.validation, emailError: false } });
      return true;
    }
    else {
      this.setState({ validation: { ...this.state.validation, emailError: true } });
      return false;
    }
  }

  validatePhone = () => {
    if (this.isPhoneOk(this.state.application.phone)) {
      this.setState({ validation: { ...this.state.validation, phoneError: false } });
      return true;
    }
    else {
      this.setState({ validation: { ...this.state.validation, phoneError: true } });
      return false;
    }
  }
  isNumberOk = (val) => {
    return true;
  }

  handleNext = async () => {
    const { activeStep } = this.state;

    // Track with GTM
    // trackButtonClick('yrityslaina_hakemus_nappi', 'loan_application_form');
    // trackLoanApplication('submit_application', {
    //   loan_amount: this.state.application.loanAmount,
    //   loan_length: this.state.application.loanLength,
    //   step: activeStep
    // });

    console.log('HANDLENEXT: Before updateApplication, tracking values in this.state.application:', {
      affiliate: this.state.application.affiliate,
      affiliateCode: this.state.application.affiliateCode,
      affiliateBrowserId: this.state.application.affiliateBrowserId,
      ga4ClientId: this.state.application.ga4ClientId,
      ga4SessionId: this.state.application.ga4SessionId
    });

    this.props.updateApplication(this.state.application);

    // Save application after step 1 (basic information step)
    if (activeStep === 0) {
      console.log("DEBUG: Setting isSavingAfterStep1 to true");
      this.setState({ isSavingAfterStep1: true });
      try {
        console.log("Saving application after step 1 (basic info):", this.state.application);
        console.log("STEP1 SAVE: Tracking values in state:", {
          affiliate: this.state.application.affiliate,
          affiliateCode: this.state.application.affiliateCode,
          affiliateBrowserId: this.state.application.affiliateBrowserId,
          ga4ClientId: this.state.application.ga4ClientId,
          ga4SessionId: this.state.application.ga4SessionId
        });
        let appl = { ...this.state.application }
        const savedApplication = await this.props.saveApplication({ ...appl, monthlyPayment: this.props.offer?.offerdata?.loanDetails?.monthlyPmt || 0 });
        console.log("Application saved successfully after step 1");
        
        // Send GTM event for loan application process completed (after FIRST save)
        const processName = this.state.application.loanApplicationTypeEnum === 1 ? 'combine_loans' : 'loan';
        trackEvent('kr_process_completed', {
          "process_name": processName,
          "value": this.state.application.loanAmount,
          "application_id": savedApplication?.id
        });
        
        // Clear the process started flag from localStorage since process is now complete
        localStorage.removeItem(`kr_process_started_${processName}`);
        
      } catch (error) {
        console.error("Error saving application after step 1:", error);
        
        // Send GTM error event
        const processName = this.state.application.loanApplicationTypeEnum === 1 ? 'combine_loans' : 'loan';
        trackEvent('kr_process_error', {
          "process_name": processName,
          "error_message": error.message || "Error saving application after step 1"
        });
        
        // Continue to next step even if save fails
      } finally {
        this.setState({ isSavingAfterStep1: false });
      }
    }

    this.setState({ activeStep: activeStep + 1 });
   
  };

  handleBack = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep - 1,
    });
  };

  handleBicChange = name => event => {
    this.setState({
      ...this.state,
      application: {
        ...this.state.application,
        [name]: event.target.value
      }
    }, () => { this.validateEmail() });
  };



  handleChange = (name, appl) => event => {
    this.handleFormInteractionStart(); // Trigger GTM event on first interaction
    
    // step0
    if (name === "email") {
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          [name]: event.target.value
        }
      }, () => { this.validateEmail() });
    }
    else if (name === "discountCode") {
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          [name]: event.target.value
        }
      }, () => {});
    }
    else if (name === "phone") {
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          [name]: event.target.value
        }
      }, () => { this.validatePhone() });
    }
    else if (name === "bic") {
      
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          [name]: event.target.value
        }
      },
        () => {

          if (this.state.application.bic.length > 8) {
            this.props.getYtjInformation(this.state.application.bic);
            this.setState({
              ...this.state,
              validation:
              {
                ...this.state.validation,
                BICError: false
              }
            });

          }

        });

    }

    else if (name === "passwordAgain") {

      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          [name]: event.target.value
        }
      }, () => { this.validatePasswordAgain() });
    }

    else if (name === "emailCode") {
      let val = event.target.value;
      this.setState({ ...this.state, emailCode: val },
        () => {

          if (val.length >= 4) {
            this.setState({
              ...this.state,
              application: {
                ...this.state.application,
                [name]: val
              }
            }, () => {
              this.props.tryValEmailCode(this.state.application);
            });
          }

        });


    }

    else if (name === "phoneCode") {
      let val = event.target.value;

      this.setState({ ...this.state, phoneCode: val },
        () => {

          if (val.length >= 4) {
            this.setState({
              ...this.state,
              application: {
                ...this.state.application,
                [name]: val
              }
            }, () => {
              this.props.tryValPhoneCode(this.state.application);
            });
          }

        });

    }
    else this.setState({
      ...this.state,
      application: {
        ...this.state.application,
        [name]: event.target.value
      }
    });
  }

  getStore() {
    return this.props.applicant;
  }
  isStepOptional = step => {
    // return step === 1;
    return false;
  };
  handleLoanPurposeTypeEnumChange = (event) => {
    this.setState({
      ...this.state,
      application: {
        ...this.state.application,
        LoanPurposeTypeEnum: event.target.value
      }
    });
  }

  handleLoanDueDateTypeEnumChange = (event) => {
    this.setState({
      ...this.state,
      application: {
        ...this.state.application,
        LoanDueDateTypeEnum: event.target.value
      }
    });

  }

  handleLoanGuaranteeTypeEnumChange = (event) => {
    this.setState({
      ...this.state,
      application: {
        ...this.state.application,
        LoanGuaranteeTypeEnum: event.target.value
      }
    });
  }

  componentDidMount = () => {
    const affiliationTrackingParams = affiliationTracking.retrieveParams();

    const values = queryString.parse(this.props.authUserId.params.id);
    const query = queryString.parse(this.props.search);
    let affiliateSrc = "";

    const affiliateCookie = getCookie('affiliation'); 

    let gclid = '';
    let fbclid = '';
    
    // Check for fbclid from _fbc cookie first (prioritized), then from saved affiliation cookie
    fbclid = affiliationTracking.getFacebookClickId() || '';
    
    if(affiliateCookie)
    {
        const affiliateData = JSON.parse(decodeURIComponent(affiliateCookie));
        gclid = getGclidFromQuery(affiliateData.query);
        
        // Only use fbclid from cookie if not already found from _fbc cookie
        if (!fbclid) {
          fbclid = getFbclidFromQuery(affiliateData.query);
        }
    }

    let consolidation = 0;
    
    if (query.replace === '1' || values.replace === '1' || query.consolidation === 'true') {
      consolidation = 1;
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          loanApplicationTypeEnum: consolidation,
        },
      });
    }

    if (values.sr !== undefined || query.sr !== undefined) {
      affiliateSrc = "Google Ads";
    }
    let affiliateCode = '';
    let affiliateBrowserId = '';
    let ga4ClientId = '';
    let ga4SessionId = '';
    
    // ALWAYS capture GA4 tracking data for all users (universal tracking)
    try {
      ga4ClientId = affiliationTracking.getGA4ClientId() || '';
      const ga4SessionData = affiliationTracking.getGA4SessionData();
      if (ga4SessionData && ga4SessionData.sessionId) {
        ga4SessionId = ga4SessionData.sessionId;
      }
    } catch (error) {
      console.warn('Could not extract GA4 data:', error);
    }
    
    // ALWAYS try to capture _fbp cookie value for Facebook Conversions API (even without fbclid)
    // This cookie persists and should be captured for all users who have visited from Facebook before
    console.log('=== COMPONENT MOUNT: Attempting to read _fbp cookie ===');
    const fbpCookieValue = affiliationTracking.getFacebookBrowserId();
    console.log('COMPONENT: getFacebookBrowserId() returned:', fbpCookieValue);
    
    // Set affiliateBrowserId to _fbp by default if it exists (will be overridden for Google Ads traffic)
    if (fbpCookieValue) {
      affiliateBrowserId = fbpCookieValue;
      console.log('COMPONENT: affiliateBrowserId set to:', affiliateBrowserId);
    } else {
      console.log('COMPONENT: affiliateBrowserId NOT set (fbpCookieValue was null/undefined)');
    }
    
    // CRITICAL: Store tracking values in instance variables to survive state updates
    this._trackingAffiliateBrowserId = affiliateBrowserId;
    this._trackingGa4ClientId = ga4ClientId;
    this._trackingGa4SessionId = ga4SessionId;
    console.log('COMPONENT: Stored in instance variables:', {
      _trackingAffiliateBrowserId: this._trackingAffiliateBrowserId,
      _trackingGa4ClientId: this._trackingGa4ClientId,
      _trackingGa4SessionId: this._trackingGa4SessionId
    });
    
    if(gclid)
    {
      affiliateCode = gclid;
      affiliateSrc = 'Google';
      
      // For Google: OVERRIDE affiliateBrowserId with GA4 Session ID (with error handling)
      try {
        const ga4SessionData = affiliationTracking.getGA4SessionData();
        if (ga4SessionData && ga4SessionData.sessionId) {
          affiliateBrowserId = ga4SessionData.sessionId;
        }
      } catch (error) {
        console.warn('Could not extract GA4 Session ID for Google:', error);
      }
    }
    if(fbclid)
    {
      affiliateCode = fbclid;
      affiliateSrc = 'Facebook';
      
      // For Facebook: affiliateBrowserId is already set to _fbp above
    }

    if (values.loanamount !== undefined && values.length !== undefined) {
      console.log('COMPONENT: Condition 1 HIT (has loanamount/length in URL)');
      console.log('COMPONENT: Setting tracking values:', {affiliateBrowserId, ga4ClientId, ga4SessionId});
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          loanAmount: values.loanamount,
          affiliateCode: affiliateCode ? affiliateCode : values.sr,
          affiliate: affiliateSrc,
          affiliateBrowserId: affiliateBrowserId,
          ga4ClientId: ga4ClientId,
          ga4SessionId: ga4SessionId,
          loanLength: values.length,
          capitalFreeMonths: values.capitalfreemonths ? values.capitalfreemonths : 0,
          loanApplicationTypeEnum: consolidation,
        }
      });
      return;
    }

    if (affiliationTrackingParams && !gclid && !fbclid) {
        console.log('COMPONENT: Condition 2 HIT (has affiliationTrackingParams)');
        this.setState({
          ...this.state,
          application: {
            ...this.state.application,
            affiliate: affiliationTrackingParams.source,
            affiliateCode: affiliationTrackingParams.code,
            affiliateParams: affiliationTrackingParams.query,
            affiliateBrowserId: affiliationTrackingParams.browserId || '',
            ga4ClientId: affiliationTrackingParams.ga4ClientId || '',
            ga4SessionId: affiliationTrackingParams.ga4SessionId || ''
          }
        })
    }

    if(gclid || fbclid){
      console.log('COMPONENT: Condition 3 HIT (has gclid or fbclid)');
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          affiliate: affiliateSrc,
          affiliateCode: affiliateCode,
          affiliateBrowserId: affiliateBrowserId,
          ga4ClientId: ga4ClientId,
          ga4SessionId: ga4SessionId
        }
      })
    }
    
    // Fallback: Always ensure GA4 values AND _fbp are set even if no affiliate tracking conditions are met
    // This handles direct traffic, organic search, and other non-tracked sources
    if (!gclid && !fbclid && !affiliationTrackingParams && !(values.loanamount !== undefined && values.length !== undefined)) {
      console.log('COMPONENT: Condition 4 HIT (fallback - no tracking params)');
      console.log('COMPONENT: Setting fallback state with affiliateBrowserId:', affiliateBrowserId);
      console.log('COMPONENT: BEFORE setState - variable values:', {
        affiliateBrowserId: affiliateBrowserId,
        ga4ClientId: ga4ClientId,
        ga4SessionId: ga4SessionId,
        'typeof affiliateBrowserId': typeof affiliateBrowserId,
        'affiliateBrowserId === ""': affiliateBrowserId === '',
        'affiliateBrowserId length': affiliateBrowserId ? affiliateBrowserId.length : 0
      });
      console.log('COMPONENT: BEFORE setState - this.state.application:', this.state.application);
      
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          affiliateBrowserId: affiliateBrowserId, // Include _fbp if it was captured
          ga4ClientId: ga4ClientId,
          ga4SessionId: ga4SessionId
        }
      }, () => {
        // Callback after setState completes
        console.log('COMPONENT: setState COMPLETED. Checking state.application tracking values:', {
          affiliate: this.state.application.affiliate,
          affiliateCode: this.state.application.affiliateCode,
          affiliateBrowserId: this.state.application.affiliateBrowserId,
          ga4ClientId: this.state.application.ga4ClientId,
          ga4SessionId: this.state.application.ga4SessionId
        });
      })
    }

    this.props.getOffer(this.state.application.loanAmount, this.state.application.loanLength, 0, this.state.application.capitalFreeMonths)

  }

  componentDidUpdate = (prevProps, prevState) => {
    console.log('COMPONENTDIDUPDATE: Called with tracking values:', {
      'prevState.affiliateBrowserId': prevState.application.affiliateBrowserId,
      'this.state.affiliateBrowserId': this.state.application.affiliateBrowserId,
      'prevProps.affiliateBrowserId': prevProps.application.affiliateBrowserId,
      'this.props.affiliateBrowserId': this.props.application.affiliateBrowserId,
      'instance._trackingAffiliateBrowserId': this._trackingAffiliateBrowserId
    });
    
    const shouldUpdateLoanOffer = (prevState.application.loanAmount != this.state.application.loanAmount 
      || prevState.application.loanLength != this.state.application.loanLength 
      || prevState.application.capitalFreeMonths != this.state.application.capitalFreeMonths )

    if (JSON.stringify(prevState.application) !== JSON.stringify(this.state.application)) {
      // ALWAYS use instance variables as source of truth when syncing to Redux
      const applicationToSync = {
        ...this.state.application,
        // Use instance variables (set once in componentDidMount, never cleared)
        affiliateBrowserId: this._trackingAffiliateBrowserId || this.state.application.affiliateBrowserId || '',
        ga4ClientId: this._trackingGa4ClientId || this.state.application.ga4ClientId || '',
        ga4SessionId: this._trackingGa4SessionId || this.state.application.ga4SessionId || ''
      };
      
      console.log('COMPONENTDIDUPDATE: Calling props.updateApplication with:', {
        affiliateBrowserId: applicationToSync.affiliateBrowserId,
        ga4ClientId: applicationToSync.ga4ClientId,
        ga4SessionId: applicationToSync.ga4SessionId
      });
      this.props.updateApplication(applicationToSync);

      if (this.getOfferDebounceHandler) {
        clearTimeout(this.getOfferDebounceHandler);
      }
      this.getOfferDebounceHandler = setTimeout(() => {
        if(shouldUpdateLoanOffer){
          this.props.getOffer(this.state.application.loanAmount, this.state.application.loanLength, 0, this.state.application.capitalFreeMonths);
        }
      }, 200);
    }
  }


  render() {
    const steps = getSteps();
    const { activeStep } = this.state;
    const { classes } = this.props;

    return (
      <Box style={{ color: "white" }}>

        <Hidden smDown>
          <div style={{ marginTop: "20px" }} />
        </Hidden>
        {this.props.application.isEmailValidated === true &&
          <Snack message={"Sähköpostiosoite " + this.state.application.email + " vahvistettu"} />
        }
        {this.state.isPhoneValidated === true &&
          <Snack message={"Matkapuhelinnumero " + this.state.application.phone + " vahvistettu"} />
        }

        <Grid container spacing={4}>

          {activeStep === 0 &&

            <Grid item xs={12}>

              {/* loan params */}
              <Grid container spacing={4}>
                <Grid item md={8}>

                  <Paper elevation={3} style={{ padding: "32px", height: '100%', borderRadius: '12px' }}>

                    <Hidden smDown>
                      <Typography variant='h3' style={{ marginBottom: '16px' }}>Uusi yrityslainahakemus</Typography>
                    </Hidden>

                    <Grid container direction='row' spacing={3} style={{ backgroundColor: '#fff', border: `1px solid ${COLOR_CENTER_BORDER}`, borderRadius: '8px', padding: '30px', textAlign: 'left' }}>
                      <Grid item xs={12}>
                        <Grid container spacing={6}>
                          <Grid item xs={12} style={{ paddingBottom: 0 }}>
                            <Grid container>
                              <Grid item xs={12}>
                                <Grid container>
                                  <Grid item xs={6}>
                                    <Typography className={classes.calculatorSliderText}>Lainasumma 1 000 € - 250 000 €</Typography>
                                  </Grid>
                                  <Grid item xs={6}>
                                    <Typography className={classes.calculatorNumber} style={{ color: '#1961E1', textAlign: 'right' }}>
                                      {this.state.application.loanAmount.toLocaleString('fi')} €
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item xs={12}>
                                <Slider
                                  value={this.state.application.loanAmount}
                                  onChange={this.handleAmountChangeSlider}
                                  min={2000}
                                  max={250000}
                                  step={1000}
                                />
                              </Grid>
                              {this.state.application.loanAmount <= 10000 && (
                                <Grid item xs={12} style={{ paddingTop: 8 }}>
                                  <Chip
                                    label="⚡ Hakemus käsitellään AI-avusteisesti, voit saada lainatarjouksen minuutissa"
                                    style={{
                                      backgroundColor: '#e8f5e9',
                                      color: '#2e7d32',
                                      fontWeight: 600,
                                      fontSize: '12px',
                                      height: 'auto',
                                      padding: '6px 4px',
                                      whiteSpace: 'normal',
                                    }}
                                  />
                                </Grid>
                              )}
                            </Grid>
                          </Grid>

                          <Grid item xs={12} md={6} style={{ paddingBottom: 0 }}>
                            <Grid container>
                              <Grid item xs={12}>
                                <Grid container>
                                  <Grid item xs={6}>
                                    <Typography className={classes.calculatorSliderText}>Laina-aika 2 kk - 48 kk</Typography>
                                  </Grid>
                                  <Grid item xs={6}>
                                    <Typography className={classes.calculatorNumber} style={{ color: '#1961E1', textAlign: 'right' }}>
                                      {this.state.application.loanLength} kk
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item xs={12}>
                                <Slider
                                  value={this.state.application.loanLength}
                                  onChange={this.handleLengthChangeSlider}
                                  min={2}
                                  max={48}
                                  step={1}
                                />
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <Grid container>
                              <Grid item xs={12}>
                                <Grid container>
                                  <Grid item xs={9}>
                                    <Typography className={classes.calculatorSliderText}>Lyhennysvapaita kuukausia 0-3 kk</Typography>
                                  </Grid>
                                  <Grid item xs={3}>
                                    <Typography className={classes.calculatorNumber} style={{ color: '#1961E1', textAlign: 'right' }}>
                                      {this.state.application.capitalFreeMonths.toLocaleString('fi')} kk
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item xs={12}>
                                <Slider
                                  value={this.state.application.capitalFreeMonths}
                                  onChange={this.handleFreeMonthsChange}
                                  min={0}
                                  max={3}
                                  step={1}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={12}>
                        <Collapse in={this.state.application.capitalFreeMonths > 0}>
                          <Grid container spacing={0}>
                            <Grid item xs={12} sm={6} className={classes.calculatorMonthlyPaymentDetailBox} style={{ borderBottom: '0 none', padding: '2px !important'}}>
                              <Typography className={classes.calculatorMonthlyPaymentDetailText}>Laina-aika</Typography>
                              <Typography className={classes.calculatorNumber}>
                                {this.props.offer.offerdata.loanParameters ? this.props.offer.offerdata.loanParameters.loanLength : 0} kk
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} className={classes.calculatorMonthlyPaymentDetailBox} style={{ borderBottom: '0 none', padding: '2px !important' }}>
                              <Typography className={classes.calculatorMonthlyPaymentDetailText}>
                                Kuukausierä ({this.state.application.capitalFreeMonths === 1 ? '1. kuukausi' : `kuukaudet 1-${this.state.application.capitalFreeMonths}` })
                              </Typography>
                              <Typography className={classes.calculatorNumber}>
                                {(Math.round(((this.props.offer.offerdata.interests ? this.props.offer.offerdata.interests[0] : 0) + Number.EPSILON) * 10) / 10).toLocaleString('fi')} € / kk
                              </Typography>
                            </Grid>
                          </Grid>
                        </Collapse>
                        <Grid container spacing={0}>
                          <Grid item xs={12} sm={6} className={classes.calculatorMonthlyPaymentDetailBox}>
                            <Typography className={classes.calculatorMonthlyPaymentDetailText}>
                              Kuukausierä
                              {this.state.application.capitalFreeMonths > 0 ? ` (kuukaudet ${this.state.application.capitalFreeMonths + 1}-${this.props.offer.offerdata.loanParameters ? this.props.offer.offerdata.loanParameters.loanLength : 0}) ` : ' '}
                              *
                            </Typography>
                            <Typography className={classes.calculatorNumber}>
                              {(Math.round(((this.props.offer.offerdata.loanDetails ? this.props.offer.offerdata.loanDetails.monthlyPmt : 0) + Number.EPSILON) * 10) / 10).toLocaleString('fi')} € / kk
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={6} className={classes.calculatorMonthlyPaymentDetailBox}>
                            <Typography className={classes.calculatorMonthlyPaymentDetailText}>Kokonaiskustannus</Typography>
                            <Typography className={classes.calculatorNumber}>
                              {(Math.round(((this.props.offer.offerdata.loanDetails ? this.props.offer.offerdata.loanDetails.totalPmt : 0) + Number.EPSILON) * 10) / 10).toLocaleString('fi')} €
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid container alignItems='center' style={{ padding: '8px 16px 4px' }}>
                        <Grid item xs={10}>
                          <Typography variant='subtitle2' >
                            Haetko yhdistelylainaa nykyisten yrityslainojen korvaamiseksi Kasvurahoituksella?
                          </Typography>
                        </Grid>
                        <Grid item xs={2} style={{ textAlign: 'center' }}>
                          <Box>
                            <Switch color="primary" checked={this.state.application.loanApplicationTypeEnum === 1} onChange={this.handleApplicationTypeCheckClick} name="checkedC" />
                          </Box>
                          <Typography variant='subtitle2' style={{ marginTop: '-6px' }}>
                            {this.state.application.loanApplicationTypeEnum === 1 ? 'Kyllä' : 'Ei'}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid item xs={12} style={{ paddingTop: 0 }}>
                        <hr style={{ margin: '4px 0' }}/>
                        <Typography variant='subtitle2' style={{ fontSize: "14px" }}>* Kuukausierän lopullinen suuruus tarkentuu riskiarviomme perusteella.</Typography>
                      </Grid>
                      <Hidden xsDown>
                      <Grid item xs={12}>
                        <div className="trustpilot-widget" data-locale="fi-FI" data-template-id="53aa8912dec7e10d38f59f36" data-businessunit-id="607582d37881d800016abf4e" data-style-height="140px" data-style-width="100%" data-theme="light" data-stars="1,2,3,4,5" data-review-languages="fi">
                          <a href="https://fi.trustpilot.com/review/kasvurahoitus.fi" target="_blank" rel="noopener">Trustpilot</a>
                        </div>
                      </Grid>
                      </Hidden>

                    </Grid>
                    

                  </Paper>


                </Grid>

                <Grid item md={4}>
                  <Paper elevation={3} style={{ padding: "32px", height: '100%', textAlign: 'left', borderRadius: '12px' }}>
                    <Typography variant='h3'>Lainahakemus</Typography>
                    <Typography variant='subtitle2' style={{ margin: '12px 0 24px' }}>Syötä yrityksen Y-tunnus ja yhteystiedot, niin voimme laatia lainatarjouksen. Voit muuttaa tietoja vielä myöhemmin.</Typography>

                    <Box style={{ position: 'relative' }}>
                      <TextField
                        autoFocus
                        error={this.state.validation.BICError}
                        helperText={this.state.validation.BICError ? 'Y-tunnus puuttuu tai on virheellinen.' : ''}
                        placeholder="Rahoitusta hakevan yrityksen Y-tunnus"
                        variant="outlined"
                        fullWidth
                        value={this.state.application.bic}
                        onChange={this.handleChange('bic')}
                      />
                      {!this.state.application.bic && (
                        <span className={classes.pointingFinger} style={{ position: 'absolute', right: '8px', top: '50%' }}>👈</span>
                      )}
                    </Box>

                    <Collapse in={this.props.application.isPrhFetched}>
                      <Typography variant='subtitle2' style={{ fontWeight: '12px', margin: '4px 0' }}>Yrityksen tiedot saatiin noudettua Patentti- ja rekisterihallitukselta. </Typography>
                    </Collapse>

                    <TextField
                      id="companyName"
                      fullWidth
                      error={this.state.validation.companyNameError}
                      placeholder="Yrityksen nimi"
                      variant="outlined"
                      value={this.state.application.companyName}
                      onChange={this.handleChange('companyName')}
                    />

                    <TextField
                      error={this.state.validation.emailError}
                      placeholder="Yhteyshenkilön sähköpostiosoite"
                      variant="outlined"
                      fullWidth
                      value={this.state.application.email}
                      onChange={this.handleChange('email')}
                    />

                    <TextField
                      fullWidth
                      error={this.state.validation.phoneError}
                      placeholder="Yhteyshenkilön puhelin"
                      variant="outlined"
                      value={this.state.application.phone}
                      onChange={this.handleChange('phone')}
                    />

                    
                    <TextField
                      fullWidth                      
                      placeholder="Kampanjakoodi"
                      variant="outlined"
                      value={this.state.application.discountCode}
                      onChange={this.handleChange('discountCode')}
                    />

                    <Box style={{ marginTop: "16px", background: '#fff', border: '1px solid #EBEBEA', textAlign: "left" }}>


                      <Grid container alignItems='center' style={{ padding: '8px 16px 16px' }}>
                        <Grid item xs={10}>
                          <Typography variant='subtitle2' style={{ fontSize: "12px" }}>
                            Olen tutustunut Kasvurahoituksen <a target="_blank" title="Kasvurahoitus yrityslaina käyttöehdot" href="https://www.kasvurahoitus.fi/front-kasvurahoitus-kaeyttoeehdot/">käyttöehtoihin</a> ja hyväksyn ne itseäni ja edustamaani yritystä sitoviksi.
                          Annan suostumuksen henkilötietojeni käyttämiseen luottokelpoisuuden arviointiin luottotietorekisteristä tehtäviin kyselyihin sekä muista saatavilla olevista tietolähteistä.
                          Hyväksyn, että lainahakemusta käsitellään AI-avusteisesti.
                          </Typography>
                          {this.state.defaultRequired === true && <Typography variant='subtitle2' style={{ color: "red" }}><br />Sinun tulee hyväksyä käyttöehtomme jatkaaksesi</Typography>}
                        </Grid>

                        <Grid item xs={2} style={{ textAlign: 'center' }}>
                          <Box>
                            <Switch color="primary" checked={this.state.defaultCheck} onChange={this.handleDefaultCheckClick} name="checkedC" />
                          </Box>
                          <Typography variant='subtitle2' style={{ marginTop: '-6px' }}>
                            {this.state.defaultCheck ? 'Kyllä' : 'Ei'}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>

                    <div style={{width: "100%", textAlign: "center"}}>


                    <Button
                      style={{ marginTop: '24px' }}
                      color="primary"
                      variant="contained"
                      endIcon={<React.Fragment>→</React.Fragment>}
                      size='large'
                      onClick={() => { this.validateFirstView() }}
                    >
                      {activeStep === steps.length - 1 ? 'Finish' : 'Pyydä lainatarjous'}
                    </Button>
                      </div>

                  </Paper>
                </Grid>

              </Grid>

              <Hidden xsDown>
                <Paper elevation={1} style={{ marginTop: '16px', padding: '16px 24px', textAlign: 'left', borderRadius: '8px' }}>
                  <Typography variant='subtitle2' style={{ fontSize: "14px" }}>
                    Oletko hakemassa yritykselle luottolimiittiä? Voit siirtyä limiittiluoton avaamiseen <a href="https://online.kasvurahoitus.fi/avaa-luottolimiitti">tästä</a>.<br/>
                    Jos olet jo asiakkaamme, voit kirjautua sivuillesi <a href="https://app.kasvurahoitus.fi/login">tästä</a>. Asiakaspalvelumme on tavoitettavissa puhelimitse numerossa +358 9 6829 8003 (ark. klo 9-16) ja sähköpostitse osoitteessa asiakaspalvelu@kasvurahoitus.fi.
                  </Typography>
                </Paper>
              </Hidden>

            </Grid>
          }

          {activeStep === 99 && <Grid item xs={12}><Paper elevation={3} style={{padding: '32px'}}>

            <div className="marginTop20" style={{ textAlign: "left" }}>
              <div className="applyForm">
                <div className="container">
                  <h1 style={{ textAlign: "center" }}>Salasana yritysportaaliin</h1>

                  <div className="applyLoanInfo2 applyForm applicationConditions">

                    <div className="row">

                      <div className="col-md-6 applyInputInfo">
                        <p>
                          Aseta salasana, jota käytät kirjautuessasi palveluun tunnuksella {this.state.application.email}</p>
                      </div>
                      <div className="col-md-1">
                        <img src="/img/icon_key.png" style={{ width: "23px", marginTop: "10px" }} />
                      </div>

                      <div className="col-md-5"> {/* content for pwd validation */}
                        <div className="row">
                          <div className="col-12 col-md-6">
                            <div className="marginTop20" />

                            <TextField
                              error={this.state.validation.passwordError}
                              label="Salasana"
                              fullWidth={true}
                              type="password"
                              value={this.state.application.password}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onChange={this.handleChange('password')} />

                            {this.state.validation.phoneError === true &&
                              <div>
                                <p>Salasanan muoto on virheellinen.</p>
                              </div>}
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="marginTop20" />
                            <TextField
                              error={this.state.validation.passwordAgainError}
                              label="Salasana uudestaan"
                              fullWidth={true}
                              type="password"
                              value={this.state.application.passwordAgain}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onChange={this.handleChange('passwordAgain')} />

                            {this.state.validation.passwordAgainError === true &&
                              <div>
                                <p>Salasanojen tulee täsmätä</p>
                              </div>}
                          </div>
                        </div>
                        {/* eof content for pwd validation */}
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </div>

            <div className="applyForm" style={{ textAlign: "left" }}>
              <div className="container">
                <h1 style={{ textAlign: "center" }}>Hakijan tiedot</h1>
                <div className="row">
                  <div className="col-md-2">
                    <img src="/img/icon_travelbook.png" style={{ width: "100px" }} />
                  </div>
                  <div className="col-md-10">

                    <div className="marginTop20"> <h1>Käyttäjätunnuksen valinta</h1> </div>
                    <div className="row">
                      <div className="col-md-6 applyInputInfo"> <p>
                        {/* <IconLock style={iconStyle}/> */} Sähköpostiosoitteesi toimii samalla käyttäjätunnuksena palveluun </p> </div>
                      <div className="col-md-1">
                        <img src="/img/icon_envelope.png" style={{ width: "23px", marginTop: "10px" }} />
                      </div>

                      <div className="col-md-5">

                        {this.props.application.isEmailValidationRequested === true && this.props.application.isEmailValidated === false &&
                          <div className="row">
                            <div className="col-12 col-md-12 applyLoanHighlight" style={{ marginTop: "20px" }}>
                              <Snack message={"Vahvistuskoodi lähetetty sähköpostiin " + this.state.application.email} />
                              <p>Lähetimme vahvistuskoodin sähköpostiisi. Ole hyvä ja syötä koodi allaolevaan kenttään. </p>
                              <div className="row">
                                <div className="col-11 col-md-11">
                                  <TextField id="emailCode"
                                    fullWidth={true}
                                    label="Tunniste"
                                    InputLabelProps={{}}
                                    value={this.state.emailCode}
                                    onChange={this.handleChange('emailCode')}
                                  />
                                </div>
                                <div className="col-1 col-md-1">
                                  {this.state.validation.BICError === false && <div> <IconOk style={okStyle} /> </div>}
                                  {this.state.validation.BICError === true && <div> <IconError style={errorStyle} /> </div>}
                                </div>
                              </div>

                              <p style={{ marginTop: "20px" }}>Etkö saanut vahvistusviestiä sähköpostiisi? Huomaathan, että viestin saapumiseen voi mennä jopa useita minuutteja. </p>
                              <Button>Lähetä uusi vahvistuskoodi</Button>
                            </div>
                          </div>
                        }

                        {this.props.application.isEmailValidationCodeRequested === true && <div style={{ textAlign: "center" }}> <CircularProgress /> </div>}
                        {this.props.application.isEmailValidationRequested === true && this.props.application.isEmailValidated === true && <div> Sähköpostiosoite <i>{this.state.application.email}</i> on vahvistettu onnistuneesti  <IconOk style={okStyle} /> </div>}

                      </div>
                    </div>
                    {/*
    {(this.props.application.isEmailValidated === true || this.props.application.isEmailValidated === false) && 
    <div className="applyLoanHighlight">
    */}

                    <div className="marginTop20">
                      <h1>Matkapuhelinnumero</h1>
                    </div>

                    <div className="row">
                      <div className="col-md-6 applyInputInfo">
                        <p>
                          Numerosta saamme tarvittaessa yhteyden hakemukseen liittyvissä asioissa </p>
                      </div>
                      <div className="col-md-1">
                        <img src="/img/icon_phone2.png" style={{ width: "23px", marginTop: "10px" }} />
                      </div>
                      <div className="col-md-5">
                        {/* content for mobile validation */}

                        <div className="row">
                          <div className="col-11 col-md-11">
                            <div className="marginTop20" />

                            <TextField
                              error={this.state.validation.phoneError}
                              label="Matkapuhelinnumero"
                              fullWidth={true}
                              value={this.state.application.phone}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onChange={this.handleChange('phone')} />
                            {/* this.state.validation.phoneError === true && <div> <p>Matkapuhelimen numeron muoto on virheellinen.</p> </div> */}
                          </div>
                          <div className="col-1 col-md-1">
                            {this.state.validation.phoneError === false && <div> <IconOk style={okStyle} /> </div>}
                            {this.state.validation.phoneError === true && <div> <IconError style={errorStyle} /> </div>}
                          </div>
                        </div>
                        {this.props.application.isPhoneValidationCodeRequested === true && <div style={{ textAlign: "center" }}> <CircularProgress /> </div>}
                        {this.props.application.isPhoneValidated === true && <div> <p>Olet vahvistanut numeron <i>{this.state.application.phone}</i> onnistuneesti <IconOk style={okStyle} /></p> </div>}

    {/* do not use Mobile validation for conversion reasons
        {this.state.validation.phoneError === false && this.props.application.isPhoneValidated === false &&
          <div className="row">
            <div className="col-12 col-md-12" style={{marginTop: "10px"}}>    
            <p>Lähetämme matkapuhelimeen vahvistustunnuksen, jolla vahvistat liittymän hallinnan.</p>   
              <Button raised color="primary"  onClick={() => {this.validatePhoneClick()}}>Lähetä vahvistusviesti</Button>  
            </div>
          </div>
        }
      */}

                        {this.props.application.isPhoneValidationRequested === true && this.props.application.isPhoneValidated === false &&
                          <div className="row">
                            <div className="col-12 col-md-12 applyLoanHighlight" style={{ marginTop: "20px" }}>
                              <Snack message={"Vahvistuskoodi lähetetty matkapuhelimeen " + this.state.application.phone} />
                              <p>Lähetimme vahvistuskoodin puhelimeesi. Ole hyvä ja syötä koodi allaolevaan kenttään. </p>
                              <div className="row">
                                <div className="col-11 col-md-11">
                                  <TextField id="phoneCode"

                                    fullWidth={true}
                                    label="Tunniste"
                                    InputLabelProps={{

                                    }}
                                    value={this.state.phoneCode}
                                    onChange={this.handleChange('phoneCode')}
                                  />
                                </div>
                              </div>
                              {/* <p style={{marginTop: "20px"}}>Etkö saanut vahvistusviestiä matkapuhelimeesi? Huomaathan, että viestin saapumiseen voi mennä jopa useita minuutteja. </p><Button>Lähetä uusi</Button> */}

                            </div>
                          </div>
                        }
                        {/* eof content for mobile validation */}
                      </div>
                    </div>
                    {/*password set*/}
                    <div className="marginTop20">
                      <h1>Salasana palveluun</h1>
                    </div>


                    {/*end of password set */}
                  </div>
                </div>
              </div>
            </div>
            </Paper>
          </Grid>
          }

          {activeStep === 1 &&

            <Grid item xs={12}>
              <Paper elevation={3} style={{ padding: "32px", textAlign: 'left' }}>
                <Typography variant='h3' style={{ marginBottom: '16px' }}>Vaihe 2 / 2</Typography>

                                  <Typography variant='body2'>
                  Pyydämme vielä tunnistautumaan pankkitunnuksilla tai mobiilivarmenteella.
                  <br />
                  Saat tiedon yritykselle tehdystä lainatarjouksesta sähköpostitse ja SMS-viestillä.
                  <br />
                  Lainatarjous on maksuton eikä sido yritystäsi vielä mihinkään.
                </Typography>

                {this.state.isSavingAfterStep1 && (
                  <Box style={{ textAlign: 'center', margin: '20px 0' }}>
                    <CircularProgress />
                    <Typography variant='body2' style={{ marginTop: '10px' }}>
                      Tallennetaan hakemustasi...
                    </Typography>
                  </Box>
                )}

                <OptionalAttachments 
                  onAttachmentsChange={this.handleAttachmentsChange} 
                  loanType={this.state.application.loanApplicationLoanTypeEnum}
                />
                {this.props.application.isFetching === true &&
                  <Box style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </Box>
                }
                {this.props.application.isFetching === false && <Box style={{ textAlign: 'center', display:'flex', paddingTop:'15px' }}>

                  <Button
                    className="applyContinueBtn"
                    color="primary"
                    variant="contained"
                    size='large'
                    onClick={() => this.setState({ bankDrawerOpen: true })}
                    disabled={this.state.isUploading}
                  >
                    {this.state.isUploading 
                      ? (this.state.attachments.length > 0 
                          ? `Lähetetään ${this.state.attachments.length} tiedosto(a)...`
                          : 'Tallennetaan hakemusta...'
                        )
                      : 'Viimeistele hakemus tunnistautumalla'
                    }
                  </Button>

                </Box>}
                <BankSelectionPanel
                  open={this.state.bankDrawerOpen}
                  onClose={() => this.setState({ bankDrawerOpen: false })}
                  onBankSelect={this.authenticate}
                  disabled={this.state.isUploading}
                  loadingServiceId={this.state.authenticatingServiceId || null}
                />
                {this.props.authentication.isAuthenticated === true && <Box style={{ textAlign: 'center' }}>
                  Hetu: {this.props.authentication.ssn}
                </Box>}
              </Paper>
            </Grid>

          }
          {activeStep === 4 &&

            <Grid item xs={12}>
              <Paper elevation={3} className="applyForm" style={{ padding: "32px", textAlign: "left" }}>

                {this.props.application.isFetching === false &&
                  <Snack message={"Tunnistautuminen onnistui " + this.props.application.firstName + " " + this.props.application.lastName + " (" + this.props.application.ssn + ")"} />
                }
                {this.props.application.isFetching === true &&
                  <Box style={{ textAlign: "center" }}>
                    <CircularProgress />
                  </Box>}
                {this.props.application.isFetching === false && <Box>
                  <Typography variant='h3' style={{ marginBottom: '16px' }}>Lainahakemuksesi on rekisteröity ja otettu käsittelyyn</Typography>

                  <Typography variant='body2'>Olemme yhteydessä yhden arkipäivän kuluessa mahdollisissa hakemuksen käsittelyyn liityvissä kysymyksissä. </Typography>

                  {this.state.activeStep === 4 &&
                    <ApplicationDetails />
                  }
                </Box>}


              </Paper>
            </Grid>

          }

          {/* Begin of Back / Forward buttons */}
          {(activeStep === steps.length || activeStep === 0) ? (
            <Box></Box>
          ) : (
              <Grid item xs={12}>
                <Typography >{getStepContent(activeStep)}</Typography>
                <Box style={{ textAlign: "right" }}>

                  <Button
                    disabled={activeStep === 0}
                    onClick={this.handleBack}
                    variant='contained'
                    color='secondary'
                    size='large'
                  >
                    Edellinen
                    </Button>

                  {this.isStepOptional(activeStep) && (
                    <Button
                      variant="contained"
                      color="secondary"
                      size='large'
                      onClick={this.handleSkip}
                    >
                      Skip
                    </Button>
                  )}

                  {(
                    (this.state.activeStep === 2 && this.state.validation.emailError === false
                      && (this.props.application.isPhoneValidated === true || this.state.validation.phoneError === false)
                      && this.state.application.password !== undefined
                      && this.state.application.passwordAgain !== undefined
                      && this.state.validation.passwordAgainError === false)

                    || (this.state.activeStep === 1 && (this.state.application.isPrhFetched === true || this.state.application.bic !== "") && this.state.defaultCheck === true && this.state.terms === true)
                  ) &&
                    <Button
                      style={{ marginLeft: "10px" }}
                      color="primary"
                      variant="contained"
                      size='large'
                      onClick={() => { 
                        console.log("DEBUG: Next button clicked, isSavingAfterStep1:", this.state.isSavingAfterStep1);
                        this.handleNext() 
                      }}
                      disabled={this.state.isSavingAfterStep1}
                    >
                      {this.state.isSavingAfterStep1 
                        ? 'Tallennetaan...'
                        : (activeStep === steps.length - 1 ? 'Finish' : 'Seuraava')
                      }
                    </Button>
                  }
                </Box>
              </Grid>
            )}
          {/* End of Back / Forward buttons */}

        </Grid>

      </Box>
    )
  }

}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)(BecomeApplicantProcess);
